import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as S from '../styles';
import StackedBar from '../charts/bar';
import 'rc-slider/assets/index.css';
import { dict } from '../dict';
import Loading from './loading';

function BarChartDepartamento(props) {
  const { dep, getCountDashboard, getCountByDep } = props;
  const [allCategories, setAllCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [barData, setBarData] = useState(null);
  const [allCount, setAllCount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setCategories(allCategories);
  }, [allCategories]);

  useEffect(() => {
    const data = {
      labels: ['FAU', dep],
      datasets: categories.map((category) => {
        return {
          label: dict(category),
          data: [],
          category,
        };
      }),
    };

    data.datasets.forEach((dataset, index) => {
      data.labels.forEach((label) => {
        dataset.backgroundColor = S.barColors.FAU[index % 6];
        dataset.data.push(allCount[label][dataset.category]);
      });
    });

    setBarData(data);
  }, [categories]);

  useEffect(() => {
    const count = { FAU: {}, dep: {} };
    getCountDashboard().then((res) => {
      count.FAU = res;
    }).then(() => {
      getCountByDep({ departamento: dep }).then((res) => {
        count[dep] = res;
        setAllCount(count);
        setAllCategories(['Produção Artística', 'Produção Técnica', 'Produção Bibliográfica',
          'Orientação', 'Bancas', 'Prêmios e Títulos']);
        setIsLoading(false);
      });
    });
  }, []);

  return (
    <BarChartContainer>
      {
        isLoading
          ? <Loading />
          : (
            <>
              <StackedBar data={barData} />
            </>
          )
      }
    </BarChartContainer>
  );
}

BarChartDepartamento.propTypes = {
  dep: PropTypes.string.isRequired,
  getCountDashboard: PropTypes.func.isRequired,
  getCountByDep: PropTypes.func.isRequired,
};

const BarChartContainer = styled.div`
    background-color: white;
    padding: 25px;
`;

export default BarChartDepartamento;
